import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { setErrors } from "./errorReducers";
import { apiClient } from "../../zodios/client";
import type { AmazonOnboardingStatus } from "../../zodios/apiDefinitions/api/amazonOnboarding";

const initialState = {
  amazon_advertising_access: "",
  amazon_additional_information: "",
  amazon_mws_access: "",
  eu_amazon_mws_access: "",
  fe_amazon_mws_access: "",
  about_your_company: "",
  payment_discovery: "",
  org_status: "",
  listings_progress: "",
  category_progress: "",
  stock_progress: "",
  last_product_status: "",
  remainder_days: null as number | null,
  visited_category_management: false,
  loaded: false,
  amazon_spapi_access: "",
  eu_amazon_spapi_access: "",
  fe_amazon_spapi_access: "",
};

const amzOnboardSlice = createSlice({
  name: "amz_onboard",
  initialState,
  reducers: {
    completeAmzProfileSelection: (state) => {
      state.amazon_additional_information = "provided";
      state.loaded = true;
    },
    updateAmzOnboardingStatus: (state, action: PayloadAction<AmazonOnboardingStatus>) => {
      // For Walmart/Shopify orgs, most fields are optional - use defaults
      state.amazon_advertising_access = action.payload.amazon_advertising_access ?? "";
      state.amazon_additional_information = action.payload.amazon_additional_information ?? "";
      state.amazon_mws_access = action.payload.amazon_mws_access ?? "";
      state.eu_amazon_mws_access = action.payload.eu_amazon_mws_access ?? "";
      state.fe_amazon_mws_access = action.payload.fe_amazon_mws_access ?? "";
      state.about_your_company = action.payload.about_your_company ?? "";
      state.payment_discovery = action.payload.payment_discovery ?? "";
      state.org_status = action.payload.org_status;
      state.listings_progress = action.payload.listings_progress ?? "";
      state.category_progress = action.payload.category_progress ?? "";
      state.stock_progress = action.payload.stock_progress ?? "";
      state.last_product_status = action.payload.last_product_status ?? "";
      state.remainder_days = action.payload.remainder_days ?? null;
      state.visited_category_management = action.payload.visited_category_management ?? false;
      state.loaded = true;
      state.amazon_spapi_access = action.payload.amazon_spapi_access ?? "";
      state.eu_amazon_spapi_access = action.payload.eu_amazon_spapi_access ?? "";
      state.fe_amazon_spapi_access = action.payload.fe_amazon_spapi_access ?? "";
    },
    resetAmzOnboarding: () => {
      return initialState;
    },
  },
});

export const { completeAmzProfileSelection, updateAmzOnboardingStatus, resetAmzOnboarding } = amzOnboardSlice.actions;
export default amzOnboardSlice.reducer;

export const refreshAmzOnboardStatus = (
  dispatchUpdateAmzOnboardingStatus: (status: AmazonOnboardingStatus) => void,
  dispatchSetErrors: typeof setErrors,
) => {
  apiClient
    .getAmazonOnboardingStatus()
    .then((amzOnboardingStatus) => {
      dispatchUpdateAmzOnboardingStatus(amzOnboardingStatus);
    })
    .catch((err) => {
      dispatchSetErrors(err);
    });
};
